import { render, staticRenderFns } from "./MainPrice.vue?vue&type=template&id=2d0e10b8&"
import script from "./MainPrice.vue?vue&type=script&lang=ts&"
export * from "./MainPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports